export default "__VITE_ASSET__6ec74558__"